var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaltReservoirSwitchOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 62,
    viewBox: "0 0 49 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M38.46,14.99V55.22a5.375,5.375,0,0,1-5.22,5.51H11.18a5.375,5.375,0,0,1-5.22-5.51V14.99",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M33.24,62H11.18a6.655,6.655,0,0,1-6.51-6.78V14.99H7.25V55.22a4.1,4.1,0,0,0,3.93,4.25H33.24a4.1,4.1,0,0,0,3.93-4.25V14.99h2.58V55.22A6.655,6.655,0,0,1,33.24,62Z",
    fill: "#6a7084"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9819",
    "data-name": "Group 9819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M29.59,27.69a3.2,3.2,0,0,1,.95,1.98l1.83,18.98a3.483,3.483,0,0,1-.9,2.67,3.914,3.914,0,0,1-2.9,1.26l-13.02.07a3.541,3.541,0,0,1-2.64-1.12,3.128,3.128,0,0,1-.85-2.42l1.66-19.35a3.393,3.393,0,0,1,3.46-3.02l9.88-.05A3.542,3.542,0,0,1,29.59,27.69Z",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9814",
    "data-name": "Group 9814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M27.52,24.2l.02,4-10.89.06-.02-4Z",
    fill: "#6a7084"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9817",
    "data-name": "Group 9817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9816",
    "data-name": "Group 9816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M16.36,47.24l.29-20.5,10.89-.06.24,20.59a1.767,1.767,0,0,1-1.77,1.77H18.12A1.765,1.765,0,0,1,16.36,47.24Z",
    fill: "#8b90a0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9818",
    "data-name": "Group 9818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M14.13,24.05a1.766,1.766,0,0,0,1.75,1.72l12.43-.06a1.767,1.767,0,0,0,1.73-1.83,4.746,4.746,0,0,0-4.77-4.7l-6.42.03a4.731,4.731,0,0,0-4.72,4.84Zm11.93-3.56c.88.86-.47,2.22-1.35,1.35S25.18,19.63,26.06,20.49Zm-3.32.02c.88.86-.47,2.22-1.35,1.35S21.87,19.65,22.74,20.51Zm-3.31.02c.88.86-.47,2.22-1.35,1.35S18.55,19.66,19.43,20.53Z",
    fill: "#6a7084"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M13.46,11.26V5.51A5.2,5.2,0,0,1,18.68.32h7.07a5.2,5.2,0,0,1,5.22,5.19v5.76",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M31.29,11.26h-.64V5.51A4.9,4.9,0,0,0,25.75.63H18.68a4.9,4.9,0,0,0-4.9,4.88v5.76h-.64V5.51A5.533,5.533,0,0,1,18.68,0h7.07a5.527,5.527,0,0,1,5.54,5.51Z",
    fill: "#404041"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9821",
    "data-name": "Group 9821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M49,15.42H3.21A2.881,2.881,0,0,1,.32,12.55V11.03A2.874,2.874,0,0,1,3.21,8.16H49",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M49,15.74H3.21A3.2,3.2,0,0,1,0,12.55V11.03A3.2,3.2,0,0,1,3.21,7.84H49v.63H3.21A2.567,2.567,0,0,0,.64,11.03v1.52a2.567,2.567,0,0,0,2.57,2.56H49Z",
    fill: "#404041"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaltReservoirSwitchOff);
export default __webpack_public_path__ + "static/media/salt_reservoir_switch_off.459881fa246809f02eb169533d31f697.svg";
export { ForwardRef as ReactComponent };